import { Box } from '@chakra-ui/react';

import { Placeholder } from '#modules/user/features/dashboard';
import { UfoIcon } from '#features/ui';

type ContentNotFoundProps = {
  title: string;
  description: string;
  action: React.ReactNode;
};

/**
 * Not-found screen for a missing entity (post, player, article), as opposed to
 * {@link ErrorNotFound}, which stays generic because six routes share it as their
 * notFoundComponent.
 */
export const ContentNotFound = ({ title, description, action }: ContentNotFoundProps) => (
  <Box w="100%">
    <Placeholder icon={<UfoIcon style={{ fontSize: '60px' }} />}>
      <Placeholder.Title>{title}</Placeholder.Title>
      <Placeholder.Description>{description}</Placeholder.Description>
      <Placeholder.Button asChild>{action}</Placeholder.Button>
    </Placeholder>
  </Box>
);
